var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePicComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.9764 0H-0.00012207V67.9766H67.9764V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9193 -23.9429H-23.9429V91.9193H91.9193V-23.9429Z",
    fill: "#1E5E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6431 -7.59101L-7.59127 27.6434C-11.0955 31.1476 -11.0955 36.829 -7.59127 40.3332L27.6431 75.5676C31.1473 79.0718 36.8287 79.0718 40.3329 75.5676L75.5673 40.3332C79.0715 36.829 79.0715 31.1476 75.5673 27.6434L40.3329 -7.59101C36.8287 -11.0952 31.1473 -11.0952 27.6431 -7.59101Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3.77952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7269 32.1461L68.7403 47.1595L75.1047 40.795C78.8756 37.0243 78.874 30.9522 75.1047 27.1816L66.8988 18.9756L53.7269 32.1461Z",
    fill: "#2CA1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8527 38.5045L29.5859 41.2378C32.9719 44.6238 38.3807 44.6239 41.7668 41.2378L50.8602 32.1444L48.1268 29.4111C44.7408 26.0251 39.332 26.0251 35.9461 29.4111L26.8527 38.5045Z",
    fill: "#97CD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4319 48.9251L25.0764 57.5696C29.2317 61.725 29.2346 68.4604 25.0764 72.6157L24.8809 72.8113L27.1756 75.1061C30.9463 78.8767 37.0183 78.8782 40.789 75.1073L67.3049 48.5916L52.2914 33.5781L43.198 42.6715C39.0427 46.8269 32.3043 46.8268 28.149 42.6715L25.4156 39.9382L16.4319 48.9251Z",
    fill: "#1E5E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71472 56.6424L23.4496 71.3773L23.6451 71.1818C27.0311 67.7958 27.0296 62.3884 23.6451 59.0024L15.0008 50.3579L8.71472 56.6424Z",
    fill: "#2CA1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2157 6.45405C36.8297 9.83996 36.8282 15.2474 40.2157 18.6334L49.561 27.9787L52.2944 30.712L65.4647 17.5415L47.2972 -0.625977L40.2157 6.45405Z",
    fill: "#1E5E96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.62768 27.731C-10.8864 31.5208 -10.7273 37.2002 -7.13281 40.7948L7.28077 55.2082L13.5651 48.9237L-7.62768 27.731Z",
    fill: "#2CA1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1991 15.8509L25.4185 37.0703L34.5119 27.9769C37.0199 25.4689 40.4674 24.4855 43.7209 25.0051L38.7817 20.0658C34.6262 15.9104 34.6264 9.17502 38.7817 5.01974L45.8616 -2.06032L40.7919 -7.12999C37.0212 -10.9007 30.9506 -10.9007 27.1799 -7.12999L4.1991 15.8509Z",
    fill: "#2CA1FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.22168 26.2719L14.9977 47.4913L23.9844 38.5045L2.76502 17.2852L-6.22168 26.2719Z",
    fill: "#97CD4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.9766,
    height: 67.9766,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicComment);
export default __webpack_public_path__ + "static/media/profile_pic_comment.d1f5ddde47410d08bc8c6640de1583ef.svg";
export { ForwardRef as ReactComponent };